import { UserType } from "../../../login/loginTypes"
import {
    COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE,
    MERCHANT_ADMIN_USERS_ROUTE,
    SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE,
    SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE,
    TENANT_USERS_ROUTE,
} from "../../../../constants/routes"
import { CreateAdmin } from "../../../users/userTypes"

type GetAdminUsersRouteArgs = Pick<CreateAdmin, "type"> & {
    includeTab?: boolean
}

export function getUsersRoute({ type, includeTab }: GetAdminUsersRouteArgs) {
    switch (type) {
        case UserType.OFFICE_MANAGER:
            return `${TENANT_USERS_ROUTE}${includeTab ? "?tab=admin" : ""}`
        case UserType.MERCHANT:
            return MERCHANT_ADMIN_USERS_ROUTE
        case UserType.COMPANY:
            return COMPANY_ADMIN_ACCOUNT_ADMINS_ROUTE
        case UserType.SUPPLIER:
            return `${SUPPLIER_ADMIN_ADMINISTRATORS_ROUTE}${includeTab ? "?tab=supplier" : ""}`
        case UserType.SUPPORT:
            //TODO: add when it'll be done
            return ""
        case UserType.SERVICE_CENTER:
            return SERVICE_CENTER_ADMIN_ACCOUNT_ADMINISTRATORS_ROUTE
    }
}
